// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"3b1c1f97","703":"b7501cea","787":"c8785b4b"}[chunkId] + ".chunk.js";
};